'use client'

import { useTranslations } from 'next-intl'
import React from 'react'

import { useRouter } from '../../i18n/routing'

export const EmptyCart: React.FC = () => {
  const t = useTranslations('common.cart')
  const router = useRouter()

  const handleGoToConfigurator = () => {
    // Simple: get the stored route from when user added to cart
    // const storedRoute = sessionStorage.getItem('lastConfiguratorRoute');

    // if (storedRoute) {
    //   router.push(storedRoute);
    // } else {
    //   router.push(routes.orders);
    // }
    // router.push('https://todobarro.com/producto/cuadrado-10/#wrapper-sim');
    router.push('https://todobarro.com')
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-8 text-center">
      {/* Empty Cart Icon */}
      <div className="mb-8">
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="text-gray-300"
        >
          <circle
            cx="60"
            cy="60"
            r="58"
            stroke="currentColor"
            strokeWidth="4"
            strokeDasharray="8 8"
          />
          <path
            d="M40 45h40l-4 25H44l-4-25z"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="48" cy="85" r="3" fill="currentColor" />
          <circle cx="72" cy="85" r="3" fill="currentColor" />
          <path
            d="M40 45L35 25H25"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Empty Cart Message */}
      <h2 className="mb-4 text-3xl font-bold text-stone-900">
        {t('emptyCart', { defaultValue: 'Tu carrito está vacío' })}
      </h2>

      <p className="mb-8 text-lg text-stone-600 max-w-md">
        {t('addProductsToStart', {
          defaultValue: 'Añade productos para comenzar tu pedido',
        })}
      </p>

      {/* Call to Action Button */}
      <button
        onClick={handleGoToConfigurator}
        className="px-8 py-3 text-xl font-medium bg-amber-300 rounded-xl hover:bg-amber-400 transition-colors cursor-pointer border-none"
      >
        {t('goToConfigurator', { defaultValue: 'Ir a todobarro' })}
      </button>

      {/* Additional Information */}
      <div className="mt-12 text-sm text-stone-500 max-w-lg">
        <p className="mb-2">
          •
          {' '}
          {t('exploreDesigns', {
            defaultValue: 'Explora nuestro catálogo de diseños únicos',
          })}
        </p>
        <p className="mb-2">
          •
          {' '}
          {t('customizeProducts', {
            defaultValue: 'Personaliza tus productos con nuestro configurador',
          })}
        </p>
        <p>
          •
          {' '}
          {t('getRealTimePrices', {
            defaultValue: 'Obtén precios en tiempo real',
          })}
        </p>
      </div>
    </div>
  )
}
